import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, UserCircle, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

const StaffPage = () => {
  const [staff, setStaff] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "staff" });

  const load = () => api.get("/staff").then((r) => setStaff(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.name || !form.email || !form.password) return toast.error("Compila tutti i campi");
    try {
      await api.post("/staff", form);
      toast.success("Membro aggiunto");
      setOpen(false);
      setForm({ name: "", email: "", password: "", role: "staff" });
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="font-cabinet font-bold text-3xl tracking-tight">Staff</h1>
          <p className="text-muted-foreground text-sm mt-1">Gestisci chi può modificare il menù.</p>
        </div>
        <button onClick={() => setOpen(true)} data-testid="add-staff-btn" className="rounded-full bg-[#002FA7] text-white font-semibold px-5 py-2.5 flex items-center gap-2 hover:bg-[#00248a]"><Plus className="w-4 h-4" /> <span className="hidden sm:inline">Aggiungi</span></button>
      </div>

      <div className="grid gap-3">
        {staff.map((u) => (
          <div key={u.user_id} className="bg-white rounded-2xl border border-border p-4 flex items-center gap-3" data-testid={`staff-${u.user_id}`}>
            <UserCircle className="w-10 h-10 text-muted-foreground" />
            <div className="flex-1 min-w-0">
              <p className="font-semibold truncate">{u.name}</p>
              <p className="text-xs text-muted-foreground truncate">{u.email}</p>
            </div>
            <span className={`text-xs font-semibold px-3 py-1 rounded-full flex items-center gap-1 ${u.role === "owner" ? "bg-[#002FA7]/10 text-[#002FA7]" : "bg-muted text-muted-foreground"}`}>
              {u.role === "owner" && <ShieldCheck className="w-3.5 h-3.5" />} {u.role === "owner" ? "Proprietario" : "Staff"}
            </span>
          </div>
        ))}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="staff-dialog">
          <DialogHeader><DialogTitle>Nuovo membro dello staff</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <input placeholder="Nome" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="staff-name" className="w-full rounded-xl border border-input px-4 py-2.5 focus:outline-none focus:border-[#002FA7]" />
            <input type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="staff-email" className="w-full rounded-xl border border-input px-4 py-2.5 focus:outline-none focus:border-[#002FA7]" />
            <input type="password" placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="staff-password" className="w-full rounded-xl border border-input px-4 py-2.5 focus:outline-none focus:border-[#002FA7]" />
            <Select value={form.role} onValueChange={(v) => setForm({ ...form, role: v })}>
              <SelectTrigger data-testid="staff-role"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="staff">Staff</SelectItem>
                <SelectItem value="owner">Proprietario</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <DialogFooter>
            <button onClick={() => setOpen(false)} className="rounded-full px-5 py-2 text-sm font-medium hover:bg-muted">Annulla</button>
            <button onClick={save} data-testid="staff-save-btn" className="rounded-full bg-[#002FA7] text-white px-5 py-2 text-sm font-semibold hover:bg-[#00248a]">Salva</button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default StaffPage;
